/**
 * React Query хуки для загрузки KLS-опций (classifier / tree select).
 */

import { useQuery } from "@tanstack/react-query";
import { klsSectionsApi } from "@/services/kls-api.service";
import type { Kls } from "@/types/api-v2";
import { klsRubrikaIndentLevel } from "@/utils/klsRubrikaHierarchy";

export interface KlsOption {
  value: number;
  label: string;
  code: string;
  shortLabel?: string;
  fullLabel?: string;
  indentLevel?: number;
}

export function useKlsOptions(qualId: number | null | undefined) {
  return useQuery<KlsOption[]>({
    queryKey: ["kls-options", qualId],
    queryFn: async () => {
      const items = await klsSectionsApi.list({
        qual_id: qualId!,
        skip: 0,
        limit: 5000,
      });
      return (items as Kls[])
        .sort((a, b) => (a.kls_rubrika || "").localeCompare(b.kls_rubrika || ""))
        .map((k) => ({
        value: k.kls_id,
        label: k.kls_names || k.kls_namef,
        shortLabel: k.kls_names || undefined,
        fullLabel: k.kls_namef,
        code: k.kls_code,
        indentLevel: klsRubrikaIndentLevel(k.kls_rubrika),
      }));
    },
    enabled: !!qualId,
    staleTime: 5 * 60_000,
  });
}
